import { render, staticRenderFns } from "./StockBaseListPage.vue?vue&type=template&id=53b77992&scoped=true&"
import script from "./StockBaseListPage.vue?vue&type=script&lang=js&"
export * from "./StockBaseListPage.vue?vue&type=script&lang=js&"
import style0 from "./StockBaseListPage.vue?vue&type=style&index=0&id=53b77992&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b77992",
  null
  
)

export default component.exports